import script from "./BatchPayoffRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchPayoffRow.vue?vue&type=script&setup=true&lang=ts"

import "./BatchPayoffRow.vue?vue&type=style&index=0&id=2cb01cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb01cc8"]])

export default __exports__